import { ColorShade } from "@/styles/nawy-theme/types";

export interface Primitives {
  black: ColorShade;
  white: ColorShade;
  grey: ColorShade;
  violet: ColorShade;
  magenta: ColorShade;
  navy: ColorShade;
  blue: ColorShade;
  cyan: ColorShade;
  green: ColorShade;
  lime: ColorShade;
  yellow: ColorShade;
  orange: ColorShade;
  red: ColorShade;
}

export const primitives: Primitives = {
  black: { 900: "#000000" },
  white: { 50: "#F4F4F4", 100: "#FFFFFF", 200: "#F4F7F8" },
  grey: {
    900: "#313131",
    800: "#4A4A4A",
    700: "#636363",
    600: "#7C7C7C",
    500: "#959595",
    400: "#AEAEAE",
    300: "#C7C7C7",
    200: "#E0E0E0",
    100: "#EBEBEB",
    50: "#F4F4F4",
  },
  violet: {
    900: "#34264A",
    800: "#443260",
    700: "#5E3E8D",
    600: "#724EA7",
    500: "#7B59AF",
    400: "#9475C2",
    300: "#B39DD5",
    200: "#C8B7E1",
    100: "#D9CFE8",
    50: "#ECE6F5",
  },
  magenta: {
    900: "#4A2646",
    800: "#60325B",
    700: "#8D3E85",
    600: "#A74E9E",
    500: "#AF59A6",
    400: "#C275BA",
    300: "#D59DCF",
    200: "#E1B7DD",
    100: "#E8CFE5",
    50: "#F5E6F3",
  },
  navy: {
    900: "#092337",
    800: "#0C314E",
    700: "#244660",
    600: "#49657A",
    500: "#6D8395",
    400: "#9EADB8",
    300: "#B5C3CD",
    200: "#C9D4DB",
    100: "#DCE4E9",
    50: "#EEF3F5",
  },
  blue: {
    900: "#002741",
    800: "#013355",
    700: "#01416D",
    600: "#01548C",
    500: "#015C9A",
    400: "#347DAE",
    300: "#5592BB",
    200: "#8AB4D1",
    100: "#B0CCE0",
    50: "#E6EFF5",
  },
  cyan: {
    900: "#004F57",
    800: "#006771",
    700: "#008592",
    600: "#00ABBB",
    500: "#00BCCE",
    400: "#33C9D8",
    300: "#54D2DE",
    200: "#8AE0E8",
    100: "#B0EAF0",
    50: "#E6F8FA",
  },
  green: {
    900: "#264A40",
    800: "#326054",
    700: "#3E8D7B",
    600: "#4EA78D",
    500: "#59AF98",
    400: "#75C2AD",
    300: "#9DD5C7",
    200: "#B7E1D7",
    100: "#CFE8E2",
    50: "#E6F5F2",
  },
  lime: {
    900: "#384A26",
    800: "#496032",
    700: "#668D3E",
    600: "#7BA74E",
    500: "#84AF59",
    400: "#9BC275",
    300: "#B9D59D",
    200: "#CCE1B7",
    100: "#DBE8CF",
    50: "#EDF5E6",
  },
  yellow: {
    900: "#5D5D13",
    800: "#797919",
    700: "#A8A823",
    600: "#CBCB2A",
    500: "#D5D533",
    400: "#DDDD5A",
    300: "#E7E78B",
    200: "#EEEDAA",
    100: "#F3F3C4",
    50: "#F9F9E2",
  },
  orange: {
    900: "#A33300",
    800: "#BF3C00",
    700: "#E64800",
    600: "#FF4F00",
    500: "#FF5E00",
    400: "#FF7E33",
    300: "#FF9354",
    200: "#FFB58A",
    100: "#FFCDB0",
    50: "#FFEFE6",
  },
  red: {
    900: "#981A13",
    800: "#AB2018",
    700: "#C72D22",
    600: "#DA3E33",
    500: "#F04438",
    400: "#F76651",
    300: "#FF8C70",
    200: "#FFB598",
    100: "#FFC8C2",
    50: "#FEECEB",
  },
};
